import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, BrainCircuitIcon, TrendingDownIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 bg-dark relative overflow-hidden" data-id="element-214">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-215">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-20 text-center" data-id="element-216">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-danger/10 text-danger mb-6 box-glow-danger" data-id="element-217">
            <AlertTriangleIcon className="w-8 h-8" data-id="element-218" />
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-extrabold text-white mb-6 uppercase tracking-wide" data-id="element-219">
            El trading en el US30{' '}
            <span className="text-danger" data-id="element-220">no perdona errores.</span>
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed font-light" data-id="element-221">
            A las 9:30 AM EST, el mercado no pregunta cómo te sientes;
            simplemente barre a quienes no tienen un plan de ejecución ciego.
          </p>
          <p className="mt-6 text-lg text-gray-400" data-id="element-222">
            Si alguna vez has sentido ese vacío en el estómago al ver cómo una
            posición mal calculada devora tu cuenta en segundos, sabes que el
            problema no es tu análisis.{' '}
            <strong className="text-white" data-id="element-223">
              El problema es tu herramienta.
            </strong>
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-224">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="glass-panel p-8 rounded-sm relative group" data-id="element-225">
            <div className="absolute top-0 left-0 w-1 h-full bg-secondary" data-id="element-226"></div>
            <BrainCircuitIcon className="w-10 h-10 text-secondary mb-6" data-id="element-227" />
            <h3 className="font-display text-xl font-bold text-white mb-4" data-id="element-228">
              Falta de Estructura
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-229">
              La mayoría de los traders pierden no por falta de conocimiento,
              sino por falta de estructura. Entras tarde porque estabas
              calculando el lotaje manualmente. Mueves el Stop Loss porque la
              emoción te domina.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="glass-panel p-8 rounded-sm relative group" data-id="element-230">
            <div className="absolute top-0 left-0 w-1 h-full bg-danger" data-id="element-231"></div>
            <TrendingDownIcon className="w-10 h-10 text-danger mb-6" data-id="element-232" />
            <h3 className="font-display text-xl font-bold text-white mb-4" data-id="element-233">
              Operando el Ruido
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-234">
              O peor aún, operas el "ruido" de la apertura de New York sin saber
              dónde está la verdadera acumulación. Sin reglas automáticas, no
              eres un trader; eres un apostador esperando que el mercado tenga
              piedad.
            </p>
            <p className="mt-4 font-display font-bold text-danger text-sm uppercase tracking-wider" data-id="element-235">
              Y el mercado no tiene piedad.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}